// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Default Desktop Styles (unchanged) */
.header {
    padding-top: 20px;
}
.header .banner {
    margin-top: 20px;
    background-color: var(--primary-color);
    background-image: var(--banner-logo);
    background-repeat: repeat-x;
    background-size: 5rem; /* Adjusted size for desktop */
    background-position: center;
    padding: 0;
    height: 3rem;
}
.header-logo img {
    height: 3rem;
}

/* Mobile-specific styles */
@media (max-width: 768px) {
    .header {
        padding-top: 10px; /* Reduce padding for smaller screens */
    }
    .header .banner {
        margin-top: 10px; /* Reduce spacing above banner */
        background-size: 3rem; /* Smaller banner background size */
        height: 2.5rem; /* Reduce height for smaller screens */
    }
    .header-logo img {
        height: 1rem; /* Adjust image height */
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/header.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,oCAAoC;IACpC,2BAA2B;IAC3B,qBAAqB,EAAE,8BAA8B;IACrD,2BAA2B;IAC3B,UAAU;IACV,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA,2BAA2B;AAC3B;IACI;QACI,iBAAiB,EAAE,uCAAuC;IAC9D;IACA;QACI,gBAAgB,EAAE,gCAAgC;QAClD,qBAAqB,EAAE,mCAAmC;QAC1D,cAAc,EAAE,sCAAsC;IAC1D;IACA;QACI,YAAY,EAAE,wBAAwB;IAC1C;AACJ","sourcesContent":["/* Default Desktop Styles (unchanged) */\n.header {\n    padding-top: 20px;\n}\n.header .banner {\n    margin-top: 20px;\n    background-color: var(--primary-color);\n    background-image: var(--banner-logo);\n    background-repeat: repeat-x;\n    background-size: 5rem; /* Adjusted size for desktop */\n    background-position: center;\n    padding: 0;\n    height: 3rem;\n}\n.header-logo img {\n    height: 3rem;\n}\n\n/* Mobile-specific styles */\n@media (max-width: 768px) {\n    .header {\n        padding-top: 10px; /* Reduce padding for smaller screens */\n    }\n    .header .banner {\n        margin-top: 10px; /* Reduce spacing above banner */\n        background-size: 3rem; /* Smaller banner background size */\n        height: 2.5rem; /* Reduce height for smaller screens */\n    }\n    .header-logo img {\n        height: 1rem; /* Adjust image height */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
